import angular from 'angular';
import 'angular-filter';
import 'angular-ui-router';
import {getDateRangeName} from '../datetime/date-ranges';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './header-timeframe.jade';

export class HeaderTimeframeController {
  /* @ngInject */
  constructor($timeout) {
    this.timeout = $timeout;
    this.timeframe = this.timeframe || {};
    this.timeframeEditCopy = _.clone(this.timeframe);
    this.rangeName = getDateRangeName(this.timeframe.startDate, this.timeframe.endDate);
  }

  applyChanges() {
    this.timeframe = _.clone(this.timeframeEditCopy);
    this.rangeName = getDateRangeName(this.timeframe.startDate, this.timeframe.endDate);
    this.timeframe.rangeName = this.rangeName;
    this.onChange && this.timeout(this.onChange);
    this.close();
  }
}

export function HeaderTimeframeComponent() {
  return {
    template,
    controller: HeaderTimeframeController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      timeframe: '=',
      hideComparison: '=',
      onChange: '&'
    },
    bindToController: true,
    link: function (scope, element) {
      element.addClass('c-header-primary__item u-2/5-large-and-up');

      scope.vm.close = () => {
        element.find('.c-header-dropdown--timeframe').removeClass('is-active');
      }
    }
  };
};


export default angular.module('header.timeframe', [
  'ui.router',
  'angular.filter',
  ServicesModule.name,
  ResourcesModule.name
])
.directive('headerTimeframe', HeaderTimeframeComponent);


/** WEBPACK FOOTER **
 ** ./src/common/header/header-timeframe.js
 **/